export const uncachedFetch = (target: string) => {
  const timestamp = new Date().getTime();
  const endpoint = `${target}?cachetime=${timestamp}`;

  return fetch(endpoint);
};
